import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import { Folder } from 'owa-folders';

export interface PublicFolderStore {
    folderTable: ObservableMap<string, Folder>; // where we store the loaded folders
    rootFolder: Folder; // root folder corresponding to IPM_SUBTREE
}

let initialState: PublicFolderStore = {
    folderTable: new ObservableMap<string, Folder>(),
    rootFolder: null,
};

let publicFolderFavoriteStore = createStore<PublicFolderStore>(
    'publicFolderFavoriteStore',
    initialState
)();

export default publicFolderFavoriteStore;
